module.exports = __webpack_public_path__ + "assets/img/352cb95452b40529c4f8040506d10e00.webp";